"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

require("./BulletBadge.scss");

var _excluded = ["text", "skin", "hideText", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** The text on the component. To make sure this component is accessible, text is required.*/
  text: _propTypes.string.isRequired,

  /** The color of the bullet */
  skin: (0, _propTypes.oneOf)(['neutral', 'success', 'warning', 'danger', 'info', 'dark']),

  /** Visually hide the text */
  hideText: _propTypes.bool,

  /** Add your own custom class names to the component */
  className: _propTypes.string
};
var defaultProps = {
  skin: 'neutral'
};
/** A text component with a colored bullet. It is suitable for displaying a status and should not include long sentences.
 *
 * */

var BulletBadge = function BulletBadge(_ref) {
  var text = _ref.text,
      skin = _ref.skin,
      hideText = _ref.hideText,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var componentClassNames = (0, _classnames.default)('rds-bullet-badge', 'rds-bullet-badge__txt', {
    'rds-bullet-badge--neutral': skin === 'neutral' || !skin || skin === 'default',
    'rds-bullet-badge--success': skin === 'success',
    'rds-bullet-badge--warning': skin === 'warning',
    'rds-bullet-badge--danger': skin === 'danger',
    'rds-bullet-badge--info': skin === 'info',
    'rds-bullet-badge--dark': skin === 'dark'
  }, className);
  var textClassNames = (0, _classnames.default)({
    'rds-is-vishidden': hideText
  });
  {
    skin === 'default' && console.error("Skin 'default' is deprecated. Please use 'neutral' instead.");
  }
  return /*#__PURE__*/_react.default.createElement("span", _extends({
    className: componentClassNames
  }, rest), /*#__PURE__*/_react.default.createElement("span", {
    className: textClassNames
  }, text));
};

BulletBadge.propTypes = propTypes;
BulletBadge.defaultProps = defaultProps;
var _default = BulletBadge;
exports.default = _default;